import { markRaw, ref } from 'vue';

/**
 * Стабільне посилання на FetchTable, яке живе разом з батьківським компонентом,
 * а не з самою таблицею.
 *
 * На відміну від $refs, хендл ніколи не буває null:
 *  - таблиця змонтована       -> виклик іде одразу;
 *  - таблиця ще не змонтована -> виклик запам'ятовується і виконається при монтуванні;
 *  - таблиця розмонтована     -> виклик безпечно ігнорується.
 */
export function createTableHandle() {
    const isMounted = ref(false);

    let table = null;
    let pendingParams = null;
    let hasPendingFetch = false;

    return markRaw({
        get isMounted() {
            return isMounted.value;
        },
        get rows() {
            return isMounted.value ? table.rows : [];
        },
        set rows(value) {
            if (isMounted.value) {
                table.rows = value;
            }
        },
        get meta() {
            return isMounted.value ? table.meta : {};
        },
        get total() {
            return isMounted.value ? table.total : 0;
        },
        get page() {
            return isMounted.value ? table.page : 1;
        },
        set page(value) {
            if (isMounted.value) {
                table.page = value;
            }
        },
        get search() {
            return isMounted.value ? table.search : '';
        },
        get selectedValues() {
            return isMounted.value ? table.selectedValues : [];
        },
        set selectedValues(value) {
            if (isMounted.value) {
                table.selectedValues = value;
            }
        },
        get isAllSelected() {
            return this.selectedValues.length !== 0 && this.selectedValues.length === this.rows.length;
        },
        connect(instance) {
            table = instance;
            isMounted.value = true;

            if (hasPendingFetch) {
                hasPendingFetch = false;

                const params = pendingParams;
                pendingParams = null;

                table.fetchRows(params);
            }
        },
        disconnect(instance) {
            if (table !== instance) {
                return;
            }

            table = null;
            isMounted.value = false;
        },
        fetchRows(params = null) {
            if (isMounted.value) {
                return table.fetchRows(params);
            }

            hasPendingFetch = true;
            pendingParams = params;

            return Promise.resolve(null);
        },
    });
}
